/* eslint-disable camelcase */
import { CONFIGS } from "../configs";
import { API } from "./API";
import { getApiUrl } from "../utils/platform";

export const getTrustedBankVisas = (query) => {
  var {
    currentPage = 1,
    itemsPerPage = 20,
    sortBy = 'created_at',
    sortOrder = -1,
    search = '',
    ...filterParams
  } = query;

  console.log("[Debug] TKT1 Trusted Bank Visa query", query);

  const page = parseInt(currentPage) || 1;
  const limit = parseInt(itemsPerPage) || 20;
  const skip = (page - 1) * limit;

  let sort = {};
  const order = parseInt(sortOrder) || -1;
  sort[sortBy] = order;

  let queryString = `currentPage=${page}&itemsPerPage=${limit}&sortBy=${sortBy}&sortOrder=${order}`;

  if (search && search.trim()) {
    queryString += `&search=${encodeURIComponent(search.trim())}`;
  }

  // Add other filter parameters
  Object.keys(filterParams).forEach(key => {
    const value = filterParams[key];
    if (value !== undefined && value !== null && value !== '') {
      queryString += `&${key}=${encodeURIComponent(value)}`;
    }
  });

  return API.get(`${getApiUrl()}/api/tkt1-trusted-visa-info/get?${queryString}`);
};

export const getTrustedBankVisaByID = (id) => {
  return API.get(`${getApiUrl()}/api/tkt1-trusted-visa-info/${id}`);
};

export const getTrustedBankVisaByVisaNumber = (visaNumber) => {
  return API.get(`${getApiUrl()}/api/tkt1-trusted-visa-info/visa/${visaNumber}`);
};

export const searchTrustedBankVisas = (query) => {
  let queryString = '';
  
  if (query && Object.keys(query).length > 0) {
    queryString = '?' + Object.keys(query)
      .filter(key => query[key] !== undefined && query[key] !== null && query[key] !== '')
      .map(key => `${key}=${encodeURIComponent(query[key])}`)
      .join('&');
  }

  return API.get(`${getApiUrl()}/api/tkt1-trusted-visa-info/search${queryString}`);
};

export const createTrustedBankVisa = (visaData) => {
  return API.post(`${getApiUrl()}/api/tkt1-trusted-visa-info/`, visaData);
};

export const updateTrustedBankVisa = (id, visaData) => {
  return API.put(`${getApiUrl()}/api/tkt1-trusted-visa-info/${id}`, visaData);
};

export const deleteTrustedBankVisa = (id) => {
  return API.delete(`${getApiUrl()}/api/tkt1-trusted-visa-info/${id}`);
};

export const tkt1TrustedBankVisaService = {
  getTrustedBankVisas,
  getTrustedBankVisaByID,
  getTrustedBankVisaByVisaNumber,
  searchTrustedBankVisas,
  createTrustedBankVisa,
  updateTrustedBankVisa,
  deleteTrustedBankVisa
};
